import { feedbackCharm_ariaLabel } from 'owa-locstrings/lib/strings/feedbackcharm_arialabel.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import HeaderCharm from './HeaderCharm';

import { FeedbackPane } from 'owa-header-pane';
import { HeaderCharmType } from 'owa-header-store';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';

const FeedbackCharm = observer(function FeedbackCharm(props: {}) {
    return (
        <HeaderCharm
            key="feedbackEntry"
            icons={{
                iconName: ControlIcons.Emoji2,
                hoverIconName: ControlIcons.Emoji,
            }}
            title={loc(feedbackCharm_ariaLabel)}
            ariaLabel={loc(feedbackCharm_ariaLabel)}
            behavior={{
                paneComponent: FeedbackPane,
                charm: HeaderCharmType.FeedbackCharm,
            }}
        />
    );
});
export default FeedbackCharm;
